import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {FormControl, Input, InputLabel, MenuItem} from '@material-ui/core';
import Select from '@material-ui/core/Select';
import Utils from "../../Utils";

const styles = theme => ({
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class MultipleSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {values: props.selected == null ? [] : props.selected};
    }

    handleChange = event => {
        this.setState({values: event.target.value});
        this.props.onChange(event.target.value);
    };

    render() {
        const {classes, theme} = this.props;
        const id = Utils.guid();
        return <FormControl className={classes.formControl} fullWidth={this.props.fullWidth !== undefined}>
            <InputLabel htmlFor={id}>{this.props.label}</InputLabel>
            <Select fullWidth={this.props.fullWidth !== undefined} multiple value={this.state.values}
                    onChange={this.handleChange} input={<Input id={id}/>}
                    style={{maxWidth: this.props.maxWidth}}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                width: 200,
                            },
                        },
                    }}>
                {this.props.values.map(value => {
                    return <MenuItem key={value} value={value} style={{
                        fontWeight:
                            this.state.values.indexOf(value) === -1
                                ? theme.typography.fontWeightRegular
                                : theme.typography.fontWeightMedium,
                    }}>
                        {value}
                    </MenuItem>
                })}
            </Select>
        </FormControl>;
    }
}

MultipleSelect.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(MultipleSelect);